import AddEditRoleModal from './components/addEditRoleModal'
import AccountFilter from './components/roleFilter'
import { StyledFilterLayout } from './index.styled'
import { IConfigRole, ICreateUpdateRole } from './interfaces'
import useColumnService from './logic/useColumnRole'
import { Row } from 'antd'
import { BreadCrumb, FooterTable } from 'components/atoms'
import { ActionType } from 'components/atoms/actions'
import { MainHeader } from 'components/templates'
import { DEBOUNCE_TIME } from 'constants/common'
import { SEARCH_QUERY_URL } from 'constants/query'
import { useModal, useProfile, useQuerySearch } from 'hooks'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { querySearchSelector } from 'store/searchQuerySlice'
import { StyledButtonIcon, StyledTable } from 'styles/styledGlobal'
import { debounce } from 'utils'

const AccountRolePage = () => {
  const modal = useModal()
  const { t } = useTranslation()
  const {
    items,
    totalRecordFilter,
    loading,
    payloadSearch,
    totalRecord,
    offset,
    handleDelete,
    handleOnSearch
  } = useQuerySearch<any>(SEARCH_QUERY_URL.ClinicRole)
  const { userId: clinicId } = useProfile()
  const { columns } = useColumnService(offset, totalRecord, handleOnAction)
  const openModal = (clinic_roles?: ICreateUpdateRole) => {
    const title = clinic_roles ? t('edit-role') : t('add-role')
    modal.open(
      <AddEditRoleModal clinic_role={clinic_roles} />,
      {
        title,
        width: 500,
        footer: null
      },
      (data) => onSearch({})
    )
  }

  function handleOnAction(action: ActionType, row: ICreateUpdateRole) {
    switch (action) {
      case ActionType.Edit:
        openModal(row)
        break
      case ActionType.Delete:
        const message = `${t('delete-role')} ${row?.role}`
        handleDelete(row?.id, message)
        break
      default:
        break
    }
  }

  const onSearch = debounce((query: IConfigRole) => {
    handleOnSearch({
      ...payloadSearch,
      query: { ...payloadSearch.query, ...query },
      offset: 0
    })
  }, DEBOUNCE_TIME)
  const query =
    useSelector(querySearchSelector)[SEARCH_QUERY_URL.ClinicRole.name]
  useEffect(() => {
    handleOnSearch({
      query: { clinic_id: clinicId },
      offset: 0,
      limit: query?.limit || 50
    })
  }, [])

  const renderRightFilter = (
    <Row>
      <StyledButtonIcon
        type="primary"
        loading={false}
        onClick={() => openModal()}
        icon={<img src="/images/ic-add-simple.svg" alt="Add" />}
        style={{ marginRight: '8px' }}
      />
    </Row>
  )

  return (
    <MainHeader
      headerTitle={
        <BreadCrumb
          breadCrumbs={[
            { name: 'account-management', path: '/' },
            { name: 'role-management', path: '' }
          ]}
        />
      }
      stickyHeader>
      <StyledFilterLayout renderRight={renderRightFilter}>
        <AccountFilter payloadSearch={payloadSearch} onSearch={onSearch} />
      </StyledFilterLayout>
      <StyledTable
        sticky
        $maxHeight="calc(100vh - 342px)"
        columns={columns as any}
        dataSource={items}
        pagination={false}
        rowKey="id"
        loading={loading}
        footer={() => (
          <FooterTable
            forPage={SEARCH_QUERY_URL.ClinicRole.name}
            totalRecord={totalRecordFilter}
          />
        )}
      />
    </MainHeader>
  )
}

export default AccountRolePage
